import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	numberFieldFormatSelectLabel: {
		id: 'platform-utils-number.number-field-configuration.number-field-format-select-label',
		defaultMessage: 'Format',
		description: 'It is a label for the select that enables user to set format for number field.',
	},
	currencyFieldSelectLabel: {
		id: 'platform-utils-number.number-field-configuration.currency-field-select-label',
		defaultMessage: 'Currency',
		description: 'It is a label for the select that enables user to set currency for number field.',
	},
	numberFormatOption: {
		id: 'platform-utils-number.number-field-configuration.number-format-option',
		defaultMessage: 'Number',
		description: 'Label for number format option',
	},
	percentageFormatOption: {
		id: 'platform-utils-number.number-field-configuration.percentage-format-option',
		defaultMessage: 'Percentage',
		description: 'Label for percentage format option',
	},
	currencyFormatOption: {
		id: 'platform-utils-number.number-field-configuration.currency-format-option',
		defaultMessage: 'Currency',
		description: 'Label for currency format option',
	},
	previewText: {
		id: 'platform-utils-number.number-field-configuration.preview-text',
		defaultMessage: '<b>Example:</b> {preview}',
		description: 'Text for the number field configuration preview example.',
	},
});
